export const CHANGE_LANGUAGE_TOGGLE = "AKASHA_CHANGE_LANGUAGE_TOGGLE";

export function changeLanguageToggle(languageId: any) {
  return {
    type: CHANGE_LANGUAGE_TOGGLE,
    payload: { language: languageId },
  };
}
